import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/media/images/about_2.webp")